import React, { PureComponent, Fragment } from 'react'
import { ThemeProvider, FelaProvider, createRenderer } from '@ycos/fela'
import { GridOverlayWrapper } from '@ycos/component-grid'
import LayoutWithMargins from '@ycos/layout-with-margins'
import getConfig from 'next/config'
import { createBrowserHistory } from 'history'
import { raygun } from '@ynap/clientside-monitoring'

const key = '__FELA_RENDERER__'

const getRenderer = (theme) => {
  if (typeof window !== 'undefined') {
    if (!window[key]) {
      window[key] = createRenderer(theme)
    }
    return window[key]
  }
  return createRenderer(theme)
}

const BaseLayout = (theme, withMargins = true) => {
  const renderer = getRenderer(theme)

  return class BaseLayoutComp extends PureComponent {
    componentDidMount() {
      const config = getConfig().publicRuntimeConfig

      if (config.raygun && config.raygun.enabled) {
        const history = createBrowserHistory()

        raygun.agent.init(config.raygun)
        raygun.helpers.routerTrackEvent(history)
        raygun.agent.footerScript()
      }
    }

    render() {
      const { children } = this.props
      const Wrapper = withMargins ? LayoutWithMargins : Fragment
      const gridOverlayConfig = getConfig().publicRuntimeConfig.useGridOverlay
      const useGridOverlay = gridOverlayConfig === undefined ? process.env.NODE_ENV !== 'production' : JSON.parse(gridOverlayConfig)

      // When executing on node side we dont need to add FelaProvider since its added in createFelaDocument, nested renders cause styles to be lost
      if (process?.versions?.node) {
        return (
          <ThemeProvider theme={theme}>
            <div dir={`${theme.useCssRTL ? "rtl" : "ltr"}`}>
              <Wrapper>{useGridOverlay === true ? <GridOverlayWrapper breakpoints={theme.breakpoints}>{children}</GridOverlayWrapper> : children}</Wrapper>
            </div>
          </ThemeProvider>
        )
      }

      return (
        <FelaProvider renderer={renderer}>
          <ThemeProvider theme={theme}>
            <div dir={`${theme.useCssRTL ? "rtl" : "ltr"}`}>
              <Wrapper>{useGridOverlay === true ? <GridOverlayWrapper breakpoints={theme.breakpoints}>{children}</GridOverlayWrapper> : children}</Wrapper>
            </div>
          </ThemeProvider>
        </FelaProvider>
      )
    }
  }
}

export default BaseLayout
